import { createContext, useContext, useMemo, useState } from "react";

const LayoutTitleContext = createContext(null);

export function LayoutTitleProvider({ children }) {
  const [pageTitle, setPageTitle] = useState(null);
  const value = useMemo(() => ({ pageTitle, setPageTitle }), [pageTitle]);
  return <LayoutTitleContext.Provider value={value}>{children}</LayoutTitleContext.Provider>;
}

export function useLayoutTitle() {
  const ctx = useContext(LayoutTitleContext);
  if (!ctx) return { pageTitle: null, setPageTitle: () => {} };
  return ctx;
}
